import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";

export const OrganizationSettings = (args: SvgIconProps) => (
  <SvgIcon {...args}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 2.25C3.35217 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35217 2.25 3.75V19.5H1.5C1.08579 19.5 0.75 19.8358 0.75 20.25C0.75 20.6642 1.08579 21 1.5 21H3H12.0218C11.7253 20.5368 11.4858 20.0335 11.3135 19.5H3.75V3.75H12.75V8.99901L12.75 9L12.75 9.00099V13.0629C13.187 12.5952 13.6923 12.1922 14.25 11.8696V9.75H20.25V11.6087C20.7955 11.8638 21.2998 12.1924 21.75 12.5818V9.75C21.75 9.35218 21.592 8.97065 21.3107 8.68934C21.0294 8.40804 20.6478 8.25 20.25 8.25H14.25V3.75C14.25 3.35218 14.092 2.97065 13.8107 2.68934C13.5294 2.40804 13.1478 2.25 12.75 2.25H3.75ZM6 6C5.58579 6 5.25 6.33579 5.25 6.75C5.25 7.16421 5.58579 7.5 6 7.5H9C9.41421 7.5 9.75 7.16421 9.75 6.75C9.75 6.33579 9.41421 6 9 6H6ZM6.75 12.75C6.75 12.3358 7.08579 12 7.5 12H10.5C10.9142 12 11.25 12.3358 11.25 12.75C11.25 13.1642 10.9142 13.5 10.5 13.5H7.5C7.08579 13.5 6.75 13.1642 6.75 12.75ZM6 15.75C5.58579 15.75 5.25 16.0858 5.25 16.5C5.25 16.9142 5.58579 17.25 6 17.25H9C9.41421 17.25 9.75 16.9142 9.75 16.5C9.75 16.0858 9.41421 15.75 9 15.75H6Z"
        fill="#FDF9F7"
      />
      <path
        d="M17.4469 19.2668C18.7054 19.2668 19.7257 18.2465 19.7257 16.9879C19.7257 15.7293 18.7054 14.709 17.4469 14.709C16.1883 14.709 15.168 15.7293 15.168 16.9879C15.168 18.2465 16.1883 19.2668 17.4469 19.2668Z"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4469 14.7092V13"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.467 15.8487L14 14.9941"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.467 18.1279L14 18.9825"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4469 19.2666V20.9758"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4268 18.1279L20.8938 18.9825"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4268 15.8487L20.8938 14.9941"
        stroke="#FDF9F7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
